import { createFileRoute } from '@tanstack/react-router';

// Define the route for the chords page
export const Route = createFileRoute('/chords')({});
